const { uaCallWithReturnValue } = require('./ua');
const { zaload } = require('./utils');
const { ZepEvent } = require('./zepEvent');
const zepConstants = require('./zepConstants');
const { version: VERSION } = require('../package.json');

function getEventingHeaders() {
    return uaCallWithReturnValue('getEventingHeaders');
}

function initialize(window, document, env, anonymousId) {
    const options = {
        zillow: {
            env,
            secure: true,
            anonymousId: anonymousId || '',
        },
    };

    const cdnUrl =
        env === zepConstants.ENVS.PROD
            ? 'https://js.zg-api.com/a/z/js/v1/analytics.js'
            : 'https://js.zg-api.test.zillow.net/a/z/js/v1/analytics.js';

    options.uaVersion = VERSION;

    zaload(window, document, 'zanalytics', cdnUrl, options);
}

module.exports = {
    initialize,
    getEventingHeaders,
    event: (eventName, version) => new ZepEvent(eventName, version),
    environments: zepConstants.ENVS,
    categories: zepConstants.CATEGORIES,
};
